import "core-js/modules/es6.function.bind";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.array.reduce";
import "core-js/modules/es6.object.define-property";

function _newArrowCheck(innerThis, boundThis) {
  if (innerThis !== boundThis) {
    throw new TypeError("Cannot instantiate an arrow function");
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
} // two types of WindowEvents:
// normal WindowEvents is called if a resize was triggered
// ratioCallback is called if aspect ratio exceeds a certain ratio


import { ResizeEvents } from "./windowEvents/ResizeEvents";
import { ScrollEvents, Visibility } from "./windowEvents/ScrollEvents";
export var WindowEvents =
/*#__PURE__*/
function () {
  function WindowEvents() {
    _classCallCheck(this, WindowEvents);
  }

  _createClass(WindowEvents, null, [{
    key: "shouldWidgetOpenAbove",
    value: function shouldWidgetOpenAbove(element) {
      return typeof window !== "undefined" && element.getBoundingClientRect().bottom / window.innerHeight > 0.6;
    }
  }, {
    key: "scrollIntoView",
    value: function scrollIntoView(element) {
      var _this = this;

      var stickyElementsHeight = typeof window !== "undefined" && WindowEvents.getStickyElements().map(function (item) {
        _newArrowCheck(this, _this);

        return item.elm;
      }.bind(this)).filter(function (elm) {
        _newArrowCheck(this, _this);

        return window.getComputedStyle(elm).visibility !== "hidden";
      }.bind(this)).map(function (elm) {
        _newArrowCheck(this, _this);

        return elm.offsetHeight;
      }.bind(this)).reduce(function (result, current) {
        _newArrowCheck(this, _this);

        return result + current;
      }.bind(this), 0);
      var scrollPos = element.offsetTop - stickyElementsHeight;
      typeof window !== "undefined" && window.scroll({
        behavior: "smooth",
        top: scrollPos
      });
    }
  }]);

  return WindowEvents;
}();
WindowEvents.Visibility = Visibility;
WindowEvents.enableResizeEvents = ResizeEvents.enable;
WindowEvents.addResizeCallback = ResizeEvents.addResizeCallback;
WindowEvents.addRatioCallback = ResizeEvents.addRatioCallback;
WindowEvents.addViewportCallback = ResizeEvents.addViewportCallback;
WindowEvents.removeResizeCallback = ResizeEvents.removeResizeCallback;
WindowEvents.removeRatioCallback = ResizeEvents.removeRatioCallback;
WindowEvents.removeViewportCallback = ResizeEvents.removeViewportCallback;
WindowEvents.getViewportSize = ResizeEvents.getViewportSize;
WindowEvents.addScrollCallback = ScrollEvents.addScrollCallback;
WindowEvents.addVisibilityCallback = ScrollEvents.addVisibilityCallback;
WindowEvents.addStickyElement = ScrollEvents.addStickyElement;
WindowEvents.removeScrollCallback = ScrollEvents.removeScrollCallback;
WindowEvents.removeVisibilityCallback = ScrollEvents.removeVisibilityCallback;
WindowEvents.removeStickyElement = ScrollEvents.removeStickyElement;
WindowEvents.getStickyElements = ScrollEvents.getStickyElements;
WindowEvents.getStickyElementsHeight = ScrollEvents.getStickyElementsHeight;